import { useEffect, useState, useCallback } from "react";
import { api } from "../api/api";

const useHistoricoAtendimento = () => {
  const [historico, setHistorico] = useState([]);

  const carregarHistorico = useCallback(async (
  dataInicial,
  dataFinal
  ) => {

    try {

      const res = await api.get(
        "/atendimento/realizados",
        {
          params: {
            dataInicial,
            dataFinal
          }
        }
      );

      setHistorico(res.data);

    } catch (error) {

      console.error(
        "Erro ao carregar histórico:",
        error
      );

    }
  }, []);

  useEffect(() => {
    carregarHistorico();
  }, [carregarHistorico]);


  const atendimentosCliente = (clienteId) => {
    return historico.filter(a => a.cliente?._id === clienteId);
  };

  // 🔥 agora usa PUT correto
  const marcarComoProcesso = async (id) => {
    try {
      await api.put(`/peticoes/${id}`, {
        virouProcesso: true
      });

      setHistorico(prev =>
        prev.map(a =>
          a._id === id ? { ...a, virouProcesso: true } : a
        )
      );

    } catch (error) {
      console.error("Erro ao atualizar petição:", error);
    }
  };

  return {
    historico,
    atendimentosCliente,
    marcarComoProcesso,
    carregarHistorico
  };
};

export default useHistoricoAtendimento;